<template>
  <div>
    <div class="container-fluid default">
      <div class="row">
        <div class="col-12 col-lg-4">
          <saved-reports></saved-reports>
        </div>
        <div class="col-12 col-lg-8">
          <saved-charts></saved-charts>
        </div>

      </div>

    </div>
  </div>
</template>
<script type="text/babel">
  import SavedReports from './SavedReports.vue';
  import SavedCharts from './SavedCharts.vue';


  export default {
    name: 'DashboardIndex',
    data: function () {
      return {

      }
    },
    components: {
      SavedReports,
      SavedCharts
    },
    created(){

    }
  }

</script>



// WEBPACK FOOTER //
// Index.vue?407726ff